export const data = [
    {
        name: "Auto marc",
        address:
            "A-55, Moolchand Shopping Complex, Ring Rd, Defence Colony, New Delhi, Delhi 110024",
        imageLink:
            "https://lh5.googleusercontent.com/p/AF1QipPHcq-pdgmpuKrxgCKSh86QPdbRzILJKsa0d1Ti=s1305-k-no",
    },
    {
        name: "Go Mechanic",
        address:
            " D-1, Satguru Ram Singh Rd, Mayapuri Industrial Area Phase II, Mayapuri, New Delhi, Delhi 110064",
        imageLink:
            "https://lh5.googleusercontent.com/p/AF1QipP42ENk_vIHMxk3N-i6iqwD20MfRxKnIYDPoXw6=s1280-k-no",
    },
    {
        name: "Harpreet Ford Serice",
        address:
            " B-120, Pocket B, Okhla Phase I, Okhla Industrial Estate, Delhi, 110044",
        imageLink:
            "https://lh5.googleusercontent.com/p/AF1QipMmWieXzh6kaWzwMRDt3_vCBq2ErMW6Vp5gnFo1=s796-k-no",
    },
    {
        name: "Wheel Force Centre ",
        address:
            "Police Station, B80 , Mayapuri Industrial Area Phase 1 Behind, Mayapuri, New Delhi, Delhi 110064",
        imageLink:
            "https://lh5.googleusercontent.com/p/AF1QipOU7lbkukzWKI8618QfFaVw_d8Z2S1VAlewqxBL=s1548-k-no",
    },
];
